/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxRedemptionTransactionHistoryItem
 */
export interface LootboxRedemptionTransactionHistoryItem {
    /**
     * Redemption record ID
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    id?: string;
    /**
     * Name of the LootBox that was opened
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    lootboxName?: string;
    /**
     * Name of the prize received
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    prizeName?: string;
    /**
     * Value of the prize (if applicable)
     * @type {number}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    prizeValue?: number;
    /**
     * Type of prize (e.g., ITEM, XP, FUEL)
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    prizeType?: string;
    /**
     * URL to prize image (if available)
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    prizeImage?: string;
    /**
     * When the LootBox was opened
     * @type {Date}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    burnedAt?: Date;
    /**
     * When the redemption was recorded
     * @type {Date}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    createdAt?: Date;
    /**
     * Human-readable description (LootBox Name - Prize Name)
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryItem
     */
    description?: string;
}

/**
 * Check if a given object implements the LootboxRedemptionTransactionHistoryItem interface.
 */
export function instanceOfLootboxRedemptionTransactionHistoryItem(value: object): value is LootboxRedemptionTransactionHistoryItem {
    return true;
}

export function LootboxRedemptionTransactionHistoryItemFromJSON(json: any): LootboxRedemptionTransactionHistoryItem {
    return LootboxRedemptionTransactionHistoryItemFromJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxRedemptionTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lootboxName': json['lootboxName'] == null ? undefined : json['lootboxName'],
        'prizeName': json['prizeName'] == null ? undefined : json['prizeName'],
        'prizeValue': json['prizeValue'] == null ? undefined : json['prizeValue'],
        'prizeType': json['prizeType'] == null ? undefined : json['prizeType'],
        'prizeImage': json['prizeImage'] == null ? undefined : json['prizeImage'],
        'burnedAt': json['burnedAt'] == null ? undefined : (new Date(json['burnedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function LootboxRedemptionTransactionHistoryItemToJSON(json: any): LootboxRedemptionTransactionHistoryItem {
    return LootboxRedemptionTransactionHistoryItemToJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryItemToJSONTyped(value?: LootboxRedemptionTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lootboxName': value['lootboxName'],
        'prizeName': value['prizeName'],
        'prizeValue': value['prizeValue'],
        'prizeType': value['prizeType'],
        'prizeImage': value['prizeImage'],
        'burnedAt': value['burnedAt'] == null ? undefined : ((value['burnedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'description': value['description'],
    };
}

